module.exports = __webpack_public_path__ + "img/alfie-w10.c718c39e.jpeg";